import {HttpClient} from '@angular/common/http';
import {Injectable, inject} from '@angular/core';
import {IDashboardActivityTypeStatus, IData} from '@evencel/models';
import {Observable} from 'rxjs';

export const DASHBOARD_URL = 'dashboard';

@Injectable({providedIn: 'root'})
export class DashboardService {
    httpClient = inject(HttpClient);

    public activityTypeStatus(
        centerId: string,
        startDate: string,
        endDate: string
    ): Observable<IData<IDashboardActivityTypeStatus>> {
        return this.httpClient.get<IData<IDashboardActivityTypeStatus>>(
            `${DASHBOARD_URL}/activity-type-status/${centerId}/${startDate}/${endDate}`
        );
    }
}
